<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent">
  <div *ngIf="Title != ''" style="text-align:justify;">
    {{Title}}
    <br />
  </div>
  <div *ngIf="items && items.length > 0" class="en" [ngClass]="isBannerType ? 'banner' : 'not_banner'">
    <div class="row styled_row" *ngFor="let item of items">
      <div class="col-12">
        <button (click)="onChange(item.key)" [disabled]="isDisabled" class=" button_link link_btn">
          <i
            [ngClass]="item.isSelected ? 'material-icons list_option_radio_on' : 'material-icons-outline list_option_radio'">
            {{item.isSelected ? (isMultiSelect ? 'check_box' : 'radio_button_checked') : (isMultiSelect ?
            'check_box_outline_blank':'radio_button_unchecked') }}</i>
          <span [ngClass]="localService.getLanguageCode(item.key)">{{item.value}}</span>
          <div class="lan_equiv {{localService.selectedLanguageCode}}" *ngIf="isShowEquivalentLanguage">
            {{localService.getEquivalentTitleById(item.key)}}
          </div>
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="itemsWithCode && itemsWithCode.length > 0" class="banner">
    <div class="row styled_row" *ngFor="let item of itemsWithCode">
      <div class="col-12">
        <button (click)="onChange(item.key)" [disabled]="isDisabled" class=" button_link link_btn">
          <i
            [ngClass]="item.isSelected ? 'material-icons list_option_radio_on' : 'material-icons-outline list_option_radio'">
            {{item.isSelected ? (isMultiSelect ? 'check_box':'radio_button_checked') : (isMultiSelect ?
            'check_box_outline_blank':'radio_button_unchecked') }}</i>
          <span [ngClass]="localService.getLanguageCode(item.v2)">{{item.v1}}</span>
        </button>
      </div>
    </div>
  </div>
</div>